/**
 * Tenant resolution from subdomain or URL parameter.
 *
 * Hierarchy:
 * 1. Subdomain: opp.ravenresume.com -> tenant "opp"
 * 2. URL param: ravenresume.com?tenant=opp -> tenant "opp"
 * 3. Default: "default" tenant (backwards compatible)
 *
 * Each tenant has a doc in tenants/ collection with:
 * { name, slug, domain, brandColor, logoUrl, createdAt }
 */

export function resolveTenant() {
    const hostname = window.location.hostname;

    // Check subdomain: xxx.ravenresume.com
    const match = hostname.match(/^([a-z0-9-]+)\.(?:ravenresume\.com|ravenresume-app\.web\.app)$/);
    if (match && !['www', 'reply'].includes(match[1])) {
        return match[1];
    }

    // Check URL parameter
    const params = new URLSearchParams(window.location.search);
    const tenantParam = params.get('tenant');
    if (tenantParam) return tenantParam;

    // Default tenant
    return 'default';
}

/**
 * Get the tenant prefix for Firestore collection paths.
 * Default tenant uses no prefix (backwards compatible).
 */
export function tenantPrefix(tenantSlug) {
    if (!tenantSlug || tenantSlug === 'default') return '';
    return `t_${tenantSlug}_`;
}
